import { useSelector } from 'react-redux';
import { getIdsForCreateBattle } from '../ducks';

export const useGetIdsForCreateBattle = () => {
  const { caseAmount, casesForBattle, price, chosenCases } = useSelector(getIdsForCreateBattle);
  return { caseAmount, casesForBattle, price, chosenCases };
};
